module.exports = __webpack_public_path__ + "67819a79c6be653a45b33497c532ffc1.fbx";